jQuery('document').ready(() => {
	/**
	 * Appointment GeoTarget
	 */
	const appointmentPage = document.getElementById('appointment-page');
	if (appointmentPage) {

		const clearURL = () => {
			const params = window.location.search;
			let url = window.location.href
			url = url.replace(params,'');
			history.pushState(null, document.title, url);
		};

		const setStep = (step) => {
			const steps = document.querySelectorAll('.steps li');
			steps.forEach((element, index) => {
				if (index === (step - 1)) {
					element.classList.add('current');
				} else {
					element.classList.remove('current');
				}
			});
		};

		const displayIFrame = (value) => {
			const blockTitle = document.getElementById('step-title');
			let text = '';
			if (value) {
				document.getElementById('calendly-iframe').classList.remove('d-none');
				text = blockTitle.dataset.titleType;
				blockTitle.scrollIntoView({ behavior: 'smooth', block: 'center'});
			} else {
				document.getElementById('calendly-iframe').classList.add('d-none');
				text = blockTitle.dataset.titleStylist;
			}

			blockTitle.innerText = text;
		};

		const updateStoreCalendly = (storeId) => {
			const data = new FormData();
			data.append('action', 'get_store_calendly');
			data.append('store_id', storeId);

			fetch(myAjax.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
				body: new URLSearchParams(data),
			})
				.then((resp) => resp.json())
				.then((response) => {
					if (response.status === 200) {
						const btn = document.querySelector('[data-calendly-url]');
						btn.dataset.calendlyUrl = response.url;
					}
				});
		};
		const displayStylists = (value) => {
			document.querySelector('.stylists-track').style.display = value ? 'grid' : 'none';
		};

		const setIframeSrcUrl = (url) => {
			document.querySelector('#calendly-iframe iframe').setAttribute('src', url + '?embed_domain=surmesur.com&embed_type=Inline');
		}

		const setStylistsListener = () => {
			document.querySelectorAll('[data-stylist-url]').forEach((btn) => {
				btn.addEventListener('click', () => {
					const url = btn.dataset.stylistUrl;
					if (url) {
						setIframeSrcUrl(url);
						setTimeout(() => {
							setStep(3);
							hideStore(true);
							displayStylists(false);
							stepOnebtn.classList.add('d-none');
							displayIFrame(true);
						}, 300);
					}
				});
			})
		}

		const stepOnebtn = document.querySelector('#step-back');

		function hideStore(hide = true) {
			const storeList = document.querySelector('#storesList');
			if (hide === true) {
				if (!storeList.classList.contains('hide')) {
					storeList.classList.add('hide');
					stepOnebtn.classList.remove('hide');
				}
			} else {
				storeList.classList.remove('hide');
				stepOnebtn.classList.add('hide');
			}
		}

		stepOnebtn.addEventListener('click', () => {
			hideStore(false);
			document.getElementById('stylists-container').classList.add('no-store-selected');
			setStep(1);
		});

		const setStoreListener = () => {
			const btn = document.querySelector('[data-calendly-url]');
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				const url = btn.dataset.calendlyUrl;
				if (url) {
					setIframeSrcUrl(url);
					setTimeout(() => {
						displayStylists(false);
						stepOnebtn.classList.add('d-none');
						displayIFrame(true);
						setStep(3);
					}, 300);
				}
			})
		};

		setStoreListener();

		const getAjaxData = (data) => {
			const form = new FormData();
			form.append('action', data.action);
			form.append('id', data.id);
			const params = new URLSearchParams(form);
			const container = document.getElementById('stylists-container');
			const containerCopy = container.cloneNode(true);
			container.classList.add('is-loading');
			fetch(myAjax.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
				body: params,
			}).then((res) => res.json())
				.then((response) => {
					if ( response.status === 200 ) {
						const stylistsTrack = container.getElementsByClassName('stylists-track')[0];
						jQuery(stylistsTrack).find('.stylist').each((i,e) => {
							jQuery(e).fadeOut(800);
							jQuery(e).addClass('deleted');
						})
						if ( response.html.length > 0 ) {
							let i = 0;
							const interval = setInterval(() => {
								if (i === response.html.length - 1) {
									setTimeout(() => {
										if (document.getElementById('stylists-container').classList.contains('no-store-selected')) {
											document.getElementById('stylists-container').classList.remove('no-store-selected');
										}

										if (document.getElementById('stylists-container').classList.contains('is-loading')) {
											document.getElementById('stylists-container').classList.remove('is-loading');
										}

										setCurrentButton(data.id);
										setStep(2);
										setStylistsListener();
										if (urlHasParam('stylist') && getParam('stylist') !== '') {
											const stylistBtn = document.querySelector(`[data-id="${getParam('stylist')}"]`);
											stylistBtn.dispatchEvent(new Event('click'));
										}

										document.querySelectorAll('.deleted').forEach((el) => {
											el.remove();
										})
									}, 400);
									clearInterval(interval);
								}
								const element = jQuery.parseHTML(response.html[i]);
								jQuery(stylistsTrack).append(element).fadeIn(600);
								i++;
							}, 400);

						} else {
							document.getElementsByClassName('stylists-track')[0].insertAdjacentHTML( 'beforeend', `<p>${container.dataset.emptyResponse}</p>`);
						}
					}
				});
		};

		const getParam = (field) => {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			return urlParams.get(field);
		};

		const urlHasParam = (field) => {
			const url = window.location.href;
			if (url.indexOf(`?${field}=`) !== -1) return true;
			return url.indexOf(`&${field}=`) !== -1;
		};

		const setCurrentButton = (id) => {
			const stores = document.querySelectorAll('[data-position]');
			stores.forEach((element) => {
				if ( element.classList.contains('current'))
					element.classList.remove('current');
			});
			document.querySelector(`[data-store-id="${id}"]`).classList.add('current');
		};

		if (urlHasParam('nogeo') && getParam('nogeo') === '1') {
			// Get all the params to display the right shop and stylists to customer.
			const shopId = getParam('id');
			const stylistId = getParam('stylist');

			if (shopId) {
				const data = { 'id': shopId, 'action': 'get_stylists' };
				getAjaxData(data);

			}

		} else {
			function geo() {
				if (! navigator.geolocation) {
					console.log('Geolocation is not supported by your browser');
					return false;
				}

				function success(position) {
					const latitude = position.coords.latitude;
					const longitude = position.coords.longitude;

					if (latitude && longitude && getParam('id') === null) {
						// Find the nearest shop
						const storesPosition = document.querySelectorAll('[data-position]');
						const nearest = [];
						if (storesPosition) {
							const getDistance = (lat1, lng1, lat2, lng2) => {
								if ((lat1 === lat2) && (lng1 === lng2)) {
									return 0;
								}
								// eslint-disable-next-line no-mixed-operators
								const radlat1 = Math.PI * lat1 / 180;
								// eslint-disable-next-line no-mixed-operators
								const radlat2 = Math.PI * lat2 / 180;
								const theta = lng1 - lng2;
								// eslint-disable-next-line no-mixed-operators
								const radtheta = Math.PI * theta / 180;
								// eslint-disable-next-line max-len
								let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
								if (dist > 1) {
									dist = 1;
								}
								dist = Math.acos(dist);
								// eslint-disable-next-line no-mixed-operators
								dist = dist * 180 / Math.PI;
								dist = dist * 60 * 1.1515;
								dist *= 1.609344;
								return dist;
							};

							storesPosition.forEach((el) => {
								const { lat, long, storeId } = el.dataset;
								nearest.push({ storeId, distance: getDistance(latitude, longitude, lat, long) });
							});

							const near = nearest.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));
							const data = { 'id': near.storeId, 'action': 'get_stylists' };
							getAjaxData(data);
							updateStoreCalendly(near.storeId);
						}
					}
				}

				function error() {
					console.log('Unable to retrieve your location');
					return false;
				}
				navigator.geolocation.getCurrentPosition(success, error);
			}

			if (getParam('id') === null) {
				setStep(1);
				geo();
			}

			if (getParam('id')) {
				const data = { 'id': getParam('id'), 'action': 'get_stylists' };
				getAjaxData(data);
				setStep(2);
				setCurrentButton(getParam('id'));
			}

			const stores = document.querySelectorAll('[data-position]');
			if (stores) {
				stores.forEach((el) => {
					el.addEventListener('click', (e) => {
						e.preventDefault();
						clearURL();
						setStep(2);
						hideStore(true);
						setCurrentButton(el.dataset.storeId);
						const data = { 'id': el.dataset.storeId, 'action': 'get_stylists' };
						getAjaxData(data)
						updateStoreCalendly(el.dataset.storeId);
					});
				});
			}
		}

		const backCalendly = document.querySelector('#calendly-back');
		if (backCalendly) {
			backCalendly.addEventListener('click', (e) => {
				e.preventDefault();
				stepOnebtn.classList.remove('d-none');
				displayIFrame(false);
				displayStylists(true);
				setStep(2);
			});
		}
	}

});
